import { runInAction } from "mobx";
import CommonStrata from "../../Models/Definition/CommonStrata";
import Input from "../../Styled/Input";
import { jsx as _jsx } from "react/jsx-runtime";
export const SelectableDimensionText = _ref => {
  let {
    id,
    dim
  } = _ref;
  return /*#__PURE__*/_jsx(Input, {
    styledHeight: "34px",
    light: true,
    border: true,
    name: id,
    value: dim.value,
    onChange: evt => {
      runInAction(() => dim.setDimensionValue(CommonStrata.user, evt.target.value));
    }
  });
};